export default "__VITE_ASSET__DcX7INS9__"